export default () => {
  const getterDevices = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia ||
                        navigator.msGetUserMedia || window.RTCPeerConnection;

  const isMiBrowser = /MiuiBrowser/gmi.test(window.navigator.userAgent);

  return getterDevices && !isMiBrowser;
};